import moment from "moment/moment";
import {capitalizeFirstLetter} from "../";

export const getShortMonthNameFromNumber = (monthNumber) => {
  return capitalizeFirstLetter(moment().month(monthNumber - 1).format("MMM"));
};